module.exports = __webpack_public_path__ + "img/hw@2x.0ab6d831.png";